import _ from 'underscore';

import { Messages } from '../../codegen/Localize';
import { IUserInfo } from '../models/IUserInfo';
import { IUser } from '../ServerApi/types/IUser';

export module UserMapper {

  export function map(serverApiUsers: IUser[]): IUserInfo[] {
    return _.map(serverApiUsers, mapOne);
  }

  export function mapOne(u: IUser): IUserInfo {
    if (u == null) {
      u = {
        displayName: Messages.hiddenUser(),
        username: '',
        id: '0',
        isHiddenInternalUser: true
      };
    }
    return {
      authId:                 u.authId,
      displayName:            u.displayName,
      domainName:             u.domainName,
      id:                     u.id,
      readOnly:               u.readOnly,
      username:               u.username,
      isHiddenInternalUser:   u.isHiddenInternalUser || false
    };
  }

  export function mapOneOwnerFromCRASS(content: any): IUserInfo {

    // TFSID:1211252 little edge case to avoid displaying hidden user for default project
    const isDefaultProjectWithNoOwner = (content.id === 1 && content.contentType === 'project' && !content.ownerName);

    const hiddenUser: boolean = !content.ownerAlias && !isDefaultProjectWithNoOwner;

    return {
      id: hiddenUser? '0' : (content.ownerId + ''),
      displayName: content.ownerName || (hiddenUser ? Messages.hiddenUser() : ''),
      username: content.ownerAlias || '',
      domainName: content.ownerDomain,
      isHiddenInternalUser: hiddenUser
    };
  }

  export function mapOneCertifierFromCRASS(content: any): IUserInfo {
    if (!content.isCertified) {
      return null;
    }

    const hiddenUser: boolean = !content.certifierUserId;
    return {
      id: hiddenUser? '0' : (content.certifierUserId + ''),
      displayName: content.certifierDisplayName || Messages.hiddenUser(),
      username: content.certifierUserName || '',
      domainName: content.certifierDomainName,
      isHiddenInternalUser: hiddenUser
    };
  }

}
